import './PendingProducts.scss'

import { Alert, Image, message, Tooltip } from 'antd'
import { getFormattedPrice } from 'helpers/Formatting'

import { useSiparisDetayQuery } from '../../gql/GeneratedGraphqlTypes'
import { ReactComponent as Hazirlaniyor } from '../../images/status-icons/hazirlaniyor.svg'
import { ReactComponent as Iade } from '../../images/status-icons/iade.svg'
import { ReactComponent as Iptal } from '../../images/status-icons/iptalTalep.svg'
import { ReactComponent as Kargo } from '../../images/status-icons/kargo.svg'
import { ReactComponent as TeslimIcon } from '../../images/status-icons/teslim.svg'
import { PendingProductsItem } from './types'
interface Props {
  siparis: string
}

const PendingProducts = ({ siparis }: Props) => {
  const temp = parseInt(siparis)
  const [messageApi] = message.useMessage()
  const isMobile = window.innerWidth <= 768
  const { data, error } = useSiparisDetayQuery({
    variables: { siparis_id: temp },
  })
  if (error) {
    messageApi.error(`${error}`, 2)
  }
  if (!data) {
    return null
  }
  const renderIcon = (status: string) => {
    switch (status) {
      case 'Hazırlanıyor':
        return <Hazirlaniyor className="status-icon" />
      case 'Teslim Edildi':
        return <TeslimIcon className="status-icon" />
      case 'Kargolandı':
        return <Kargo className="status-icon" />
      case 'İade Edildi':
        return <Iade className="status-icon" />
      case 'İptal Talebi':
        return <Iptal className="status-icon" />
      default:
        return null // Eğer durum tanımlanmamışsa hiçbir şey döndürme
    }
  }

  const PendingProductsItems: PendingProductsItem[] =
    data?.siparisDetay.satirlar
      ?.filter((urun) => {
        const isDynamicPackage = urun?.urun.bilgiler?.some(
          (bilgi) => bilgi?.isim === 'Dinamik Koli Ürünü' && bilgi.deger === 'True',
        )
        return urun?.durum === 'Hazırlanıyor' && !isDynamicPackage
      })
      .map((urun) => {
        return {
          key: urun?.id?.toString() || '', //Gerekli
          urun_isim: urun?.urun.isim || '',
          aciklamalar: urun?.urun.aciklamalar || '',
          adet: urun?.adet ?? 0,
          kalan_adet: urun?.kalan_adet ?? 0,
          birim_fiyat: getFormattedPrice(urun?.birim_fiyat?.toString() ?? '0') || '0',
          kdv_dahil_fiyat:
            getFormattedPrice((parseFloat(urun?.birim_fiyat ?? '0') * (urun?.adet ?? 0)).toString()) || '0',
          durum: urun?.durum || '',
          images: (urun?.urun.resimler as string[]) || [],
        }
      }) || []

  return (
    <>
      <div className="pending-products">
        <Alert
          className="custom-alert"
          description="Hazırlanmakta olan ürünler listelenmektedir."
          type="success"
        />
        <br />
        {
          isMobile ?
          
              <div className="order-detail-products-container-mobile">
            {PendingProductsItems.map((urun) => (
              <div key={urun.key} className={`product-item`}>
                <div className="left-side">
                  <Image src={urun.images[0] ?? ''} alt={urun.urun_isim} className="product-image" width={72} height={72} />
                  <div className="product-name-wrapper">
                    <span className="product-name">{urun.urun_isim}</span>
                    {urun.aciklamalar && <span className="product-aciklama"><span className="aciklama-label">Açıklama:</span> {urun.aciklamalar}</span>}
                  </div>
                </div>
                <div className="right-side">
                  <p className="info">
                    <span>Adet:</span>
                    {urun.adet}
                  </p>
                  <p className="info">
                    <span>Bekleyen Adet: </span>
                    {urun.adet}
                  </p>
                  <p className="info">
                    <span>KDV Dahil Birim Fiyat: </span>
                    {urun.birim_fiyat} TL
                  </p>
                  <p className="info">
                    <span>KDV Dahil Tutar:</span>
                    {urun.kdv_dahil_fiyat} TL
                  </p>
                  <div className="product-status info">
                    <span>Durum: </span>
                    {renderIcon(urun.durum)}
                    {urun.durum}
                  </div>
                </div>
              </div>
            ))}
          </div>
          : 
            <div className="order-detail-products-container">
          <div className="product-item-header">
            <span className="name">Ürün Adı</span>
            <span>Adet</span>
            <span>Bekleyen Adet</span>
            <span>KDV Dahil Birim Fiyat</span>
            <span>KDV Dahil Tutar</span>
            <span>Durum</span>
          </div>
          {PendingProductsItems.map((urun) => (
            <div key={urun.key} className="product-item">
              <div className="left-side">
                <Image src={urun.images[0] ?? ''} alt={urun.urun_isim} className="product-image" width={72} height={72} />
                <div className="product-name-wrapper">
                  <Tooltip title={urun.urun_isim} placement="top">
                    <span className="product-name">
                      {urun.urun_isim.length > 45 ? `${urun.urun_isim.slice(0, 45)}...` : urun.urun_isim}
                    </span>
                  </Tooltip>
                  {urun.aciklamalar && <span className="product-aciklama"><span className="aciklama-label">Açıklama:</span> {urun.aciklamalar}</span>}
                </div>
              </div>
              <p className="quantity">{urun.adet}</p>
              <p>{urun.adet}</p>
              <p>{urun.birim_fiyat}</p>
              <p>{urun.kdv_dahil_fiyat}</p>
              <div className="product-status">
                {renderIcon(urun.durum)}
                {urun.durum}
              </div>
            </div>
          ))}
        </div>
        }
      
      </div>
    </>
  )
}

export default PendingProducts

